module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2025_de-c6c3df8affe467bacc4a47783ea6af8b.jpg";